export const CARGO_TYPES: string[] = [
  'Шины',
  'Бытовая техника',
  'Стройматериалы',
  'Мебель',
  'Оборудование',
  'Другое',
]
